import { Icon } from '@iconify/react'
import classNames from 'classnames'
import type { ButtonHTMLAttributes } from 'react'

import styles from 'features/TeamChat/teamChat.module.scss'

type Variant = 'primary' | 'secondary' | 'outline'
type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
  loading?: boolean
  grow?: boolean
}

const VARIANT = {
  primary: styles.btnPrimary,
  secondary: styles.btnSecondary,
  outline: styles.btnOutline,
}

// The widget's own button: the design's 44px teal and white buttons, not the app's form buttons.
export const TeamButton = ({
  variant = 'primary',
  loading,
  grow,
  className,
  children,
  ...rest
}: Props) => (
  <button
    type='button'
    {...rest}
    aria-busy={loading || undefined}
    className={classNames(styles.btn, VARIANT[variant], { [styles.grow]: grow }, className)}>
    {loading && (
      <Icon icon='lucide:loader-circle' width={18} className={styles.spin} aria-hidden='true' />
    )}
    {children}
  </button>
)
